import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-tax',
  templateUrl: './invoice-tax.component.html',
  styleUrls: ['./invoice-tax.component.scss']
})
export class InvoiceTaxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
